import { render, staticRenderFns } from "./ImportBtn.vue?vue&type=template&id=6d2a0318"
import script from "./ImportBtn.vue?vue&type=script&lang=ts"
export * from "./ImportBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports